/* ─────────────────────────────────────────────
   Good Sleep - Global JS
   ───────────────────────────────────────────── */

(function () {
  'use strict';

  /* ── Nav scroll state ── */
  const nav = document.querySelector('.gs-nav');
  if (nav) {
    const onScroll = () => nav.classList.toggle('is-scrolled', window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Mobile nav toggle ── */
  const navToggle = document.querySelector('.gs-nav__toggle');
  const navLinks  = document.querySelector('.gs-nav__links');
  if (navToggle && navLinks) {
    navToggle.addEventListener('click', () => {
      const open = navLinks.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', open);
    });
  }

  /* ── Scroll reveal ── */
  const revealEls = document.querySelectorAll('.gs-reveal');
  if (revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(el => io.observe(el));
  }

  /* ── Cart count ── */
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const counts = document.querySelectorAll('.gs-nav__cart-count');
        counts.forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(() => {});
  }
  updateCartCount();

  /* ── Expose for section scripts ── */
  window.GS = window.GS || {};
  window.GS.updateCartCount = updateCartCount;

})();
